module.exports = __webpack_public_path__ + "img/img_employee.96521a8f.svg";